import { ns } from '@leverege/i18n';
import { Checkbox, PropertyGrid, TextInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ModelEditorFactory } from '@leverege/ui-plugin';
import React from 'react';
import Model from "./UnitAttributeExportFieldModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.export.UnitAttributeExportFieldEditor');
function UnitAttributeExportFieldEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  const customFormat = Model.getCustomFormat(value);
  const formatter = Model.getFormatter(value);
  const formatterEditor = customFormat && formatter && ModelEditorFactory.create(formatter, {
    eventData: 'setFormatter',
    onChange: onModelChange
  });
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    style: {
      backgroundColor: 'var(--color-white)'
    },
    children: [/*#__PURE__*/_jsx(PropertyGrid.Header, {
      style: {
        margin: '10px 0',
        fontSize: 18,
        fontWeight: 'bold'
      },
      title: t('header')
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('label'),
      children: /*#__PURE__*/_jsx(TextInput, {
        eventData: "setHeaderLabel",
        hint: t('labelHint'),
        value: Model.getHeaderLabel(value),
        onChange: onModelChange
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Header, {
      style: {
        margin: '10px 0',
        fontSize: 18,
        fontWeight: 'bold'
      },
      title: t('data')
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: t('emptyValue'),
      children: /*#__PURE__*/_jsx(TextInput, {
        eventData: "setEmptyValue",
        hint: t('emptyValueHint'),
        value: Model.getEmptyValue(value),
        onChange: onModelChange
      })
    }), formatter && /*#__PURE__*/_jsx(PropertyGrid.Item, {
      fillCell: true,
      label: t('customFormat'),
      children: /*#__PURE__*/_jsx(Checkbox, {
        eventData: "setCustomFormat",
        value: customFormat,
        onChange: onModelChange
      })
    }), formatterEditor && /*#__PURE__*/_jsx(PropertyGrid.Item, {
      fill: true,
      inset: true,
      label: t('format'),
      children: formatterEditor
    })]
  });
}
export default /*#__PURE__*/React.memo(UnitAttributeExportFieldEditor);